// Sidebar.js
import React from "react";
import { useLocation } from "react-router-dom";

const Sidebar = () => {
  const location = useLocation();
  const isWorkPage = location.pathname.startsWith("/work");
  const isContactPage = location.pathname.startsWith("/contact");
  const isAboutPage = location.pathname.startsWith("/about");
  return (
    <div>
      <div
        className={`fixed flex items-center justify-between w-full p-3 z-50 md:w-12  md:flex md:flex-col md:justify-between md:items-center md:py-4 md:h-screen  md:font-semibold ${
          isWorkPage
            ? "hidden md:text-beige"
            : isAboutPage
            ? "hidden"
            : isContactPage
            ? "hidden md:text-lightBrown"
            : "text-midBrown"
        } `}
      >
        <div className="flex flex-row md:flex-col gap-4 md:gap-6 md:mt-8">
          <div className="md:text-sm md:-rotate-45 md:w-12 md:flex md:justify-center">
            <a
              href="https://github.com/abbiekuma"
              target="_blank"
              rel="noopener noreferrer"
              children
              className="hover:underline"
            >
              <i class="fa-brands fa-github"></i>
            </a>
          </div>
          <div className="md:text-sm md:-rotate-45 md:w-12 md:flex md:justify-center">
            <a
              href="http://www.linkedin.com/in/abbieluoyu"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline"
            >
              <i class="fa-brands fa-linkedin"></i>
            </a>
          </div>
          <div className="md:text-sm md:-rotate-45 md:w-12 md:flex md:justify-center">
            <a href="mailto:abbieluo.yu@gmail.com">
              <i class="fa-regular fa-envelope"></i>
            </a>
          </div>
        </div>

        {/* line */}
        <div
          className={`h-px w-24 rounded mb-1 mr-20 md:w-px md:h-60 md:mb-64 md:mr-0 ${
            isWorkPage
              ? "bg-beige"
              : isContactPage
              ? "bg-lightBrown"
              : "bg-midBrown"
          }`}
        ></div>

        {/* bottom */}
        <div className="text-xs md:-rotate-90 font-semibold md:mb-8 ">
          ©2025
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
